import { render } from "./ShowFiltersButton.vue?vue&type=template&id=4fdc84b4"
import script from "./ShowFiltersButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowFiltersButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/ShowFiltersButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fdc84b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fdc84b4', __exports__)) {
    api.reload('4fdc84b4', __exports__)
  }
  
  module.hot.accept("./ShowFiltersButton.vue?vue&type=template&id=4fdc84b4", () => {
    api.rerender('4fdc84b4', render)
  })

}


export default __exports__